import React, {useState} from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Button from '/component/base/Button';
import Checkbox from '/component/base/Checkbox/Checkbox';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import NavigationHeader from '/component/layout/NavigationHeader';
import {DownlineProfile} from '/constant/TestIDs';
import {MERGE_PROFILES_TITLE} from '/enum/candidates.enum';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {getCloseIconPressHandler} from '../MergeCandidate.util';

import {styles} from './FirstMergeScreen.style';
interface FirstMergeScreenProps {
  onClosePress: () => void;
  onNextPress: (appendPhoneNumber: boolean) => void;
  phoneNumber: string | null;
}

export const FirstMergeScreen: React.FC<FirstMergeScreenProps> = ({
  onClosePress = noop,
  onNextPress = noop,
  phoneNumber = null,
}) => {
  const [appendPhoneNumber, setAppendPhoneNumber] = useState(true);
  const {ts} = useTranslation('screen.CandidateProfile.mergeScreen');

  const changeNum = (num: string | null) =>
    num ? num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : num;

  const checkBoxStyle = appendPhoneNumber
    ? styles.selectedIcon
    : styles.unSelectedIcon;
  const checkBoxIconName = appendPhoneNumber
    ? 'checkbox-selected'
    : 'checkbox-unselected';
  const tileStyle = appendPhoneNumber
    ? styles.tileEnabled
    : styles.tileDisabled;

  return (
    <NavigationHeader
      style={{base: styles.base, title: styles.title}}
      rightIcons={['close']}
      onIconPress={getCloseIconPressHandler(onClosePress)}
      title={MERGE_PROFILES_TITLE}
      testID={DownlineProfile.mergeScreen}>
      <Gutter style={styles.contentContainer}>
        <View>
          <View style={styles.infoContainer}>
            <Icon
              name="alert"
              style={styles.alertIcon}
              testID={DownlineProfile.mergeScreenWarningIcon}
            />
            <Text
              style={styles.infoText}
              {...testProperties(DownlineProfile.mergeScreenDescription)}>
              The following information from the Candidate’s profile will be
              <Text variant="button"> deleted</Text>. Be sure to record this
              information if you still need it.
            </Text>
          </View>

          <View
            style={tileStyle}
            {...testProperties(DownlineProfile.mergeScreenPhoneTile)}>
            <View>
              <View style={styles.tileHeadingContainer}>
                <Icon name="phone" style={styles.phoneIcon} />
                <Text
                  variant="heading"
                  {...testProperties(DownlineProfile.mergeScreenPhoneLabel)}>
                  {ts('phone', 'Phone')}
                </Text>
              </View>

              <Text {...testProperties(DownlineProfile.mergeScreenPhoneValue)}>
                {phoneNumber ? changeNum(phoneNumber) : 'N/A'}
              </Text>
            </View>

            <View style={styles.checkboxContainer}>
              <Text
                {...testProperties(
                  DownlineProfile.mergeScreenPhoneAddToNotesLabel,
                )}>
                {ts('addToNotes', 'Add to notes')}
              </Text>
              <Checkbox
                checked={appendPhoneNumber}
                rectangleCheckbox
                style={{icon: checkBoxStyle}}
                checkedIconName={checkBoxIconName}
                onChange={() => setAppendPhoneNumber(!appendPhoneNumber)}
              />
            </View>
          </View>
        </View>

        <Button
          style={{base: styles.button}}
          onPress={() => onNextPress(appendPhoneNumber)}
          {...testProperties(DownlineProfile.mergeScreenNext)}>
          {ts('next', 'Next')}
        </Button>
      </Gutter>
    </NavigationHeader>
  );
};
